
<input type="text" placeholder="Filter" (input)="applyFilter2($event)">

<table class="inbox-table">
  <thead>
    <tr>
      <th width="10px" (click)="sortColumn('subject')">Subject</th>
      <th>Sender</th>
      <th (click)="sortColumn('date')">Date</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let message of filteredDataSource"
        (mouseover)="message.hover = true"
        (mouseleave)="message.hover = false">
      <td width="100px">{{ message.subject }}</td>
      <td>{{ message.sender }}</td>
      <td >{{ message.date }}
    </td>
        <td *ngIf="message.hover">
          <button  (mouseover)="message.hover = true" (click)="edit(message)" mat-icon-button >
            <mat-icon (mouseover)="message.hover = true">edit</mat-icon>
          </button>
          <button  (mouseover)="message.hover = true" (click)="delete(message)" mat-icon-button *ngIf="message.hover">
            <mat-icon (mouseover)="message.hover = true">archive</mat-icon>
          </button>
        </td>


      
    </tr>
  </tbody>
</table>


<div>
  <button [disabled]="currentPage === 1" (click)="previousPage()">Previous</button>
  <span>{{ currentPage }} / {{ totalPages }}</span>
  <button [disabled]="currentPage === totalPages" (click)="nextPage()">Next</button>
</div>
<br>
<br>




<div class="table-container">
  <!-- <mat-form-field appearance="outline" class="filter-input">
    <mat-icon matPrefix>search</mat-icon>
   <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
  </mat-form-field> -->

  <table mat-table [dataSource]="dataSource3" matSort>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
      <td mat-cell *matCellDef="let item"> {{ item.name }} </td>
    </ng-container>

    <ng-container matColumnDef="age">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Age </th>
      <td mat-cell *matCellDef="let item"> {{ item.age }} </td>
    </ng-container>

    <!-- Add more columns as needed -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns3;"></tr>
  </table>
</div>

